import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const impervaWaf = defineConnector({
  identifier: "impervaWaf",
  name: "Imperva WAF",
  tagLine: "Web application firewall",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.imperva\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "x-API-Id", value: app.secret.apiId },
      { name: "x-API-Key", value: app.secret.apiKey },
    ]),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your Imperva Cloud WAF console, navigate to **Account → API** and copy your API ID and API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API ID",
          required: true,
          target: { kind: "secrets", field: "apiId" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.imperva.com/site/status",
  },
});
